import { useEffect, useRef } from 'react';

/* Adds .cp-revealed to every .cp-reveal element inside the ref'd root
   as it scrolls into view. Safety net: any element still hidden after
   3s is revealed anyway, so content can never be stranded invisible. */
export default function useScrollReveal() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const els = Array.from(root.querySelectorAll('.cp-reveal'));

    if (typeof IntersectionObserver === 'undefined') {
      els.forEach((el) => el.classList.add('cp-revealed'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('cp-revealed');
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));

    const fallback = setTimeout(() => {
      els.forEach((el) => {
        if (!el.classList.contains('cp-revealed')) {
          el.classList.add('cp-revealed');
        }
      });
    }, 3000);

    return () => {
      io.disconnect();
      clearTimeout(fallback);
    };
  }, []);

  return rootRef;
}
